// src/modules/Rules/adapters/CourierIntegrationApiAdapter.ts
import { HttpClient } from '@adapters/HttpClient';

export interface IntegrationOption {
  id: string; // integration.id
  name: string; // integration.name
  courierId: string; // integration.courier_id
  isActive: boolean; // integration.is_active
}

export interface ServiceOption {
  id: string;
  name: string;
}

export class CourierIntegrationApiAdapter {
  private integrationsCache: IntegrationOption[] = [];

  constructor(private httpClient: HttpClient) {}

  /**
   * Devuelve lista de integraciones con su courier_id
   * y las guarda en una caché interna.
   */
  async getAll(): Promise<IntegrationOption[]> {
    const raw = await this.httpClient.get<any>('/couriers/integrations');
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    this.integrationsCache = list.map((c: any) => ({
      id: String(c.id),
      name: c.name,
      courierId: String(c.courier_id),
    }));
    return this.integrationsCache;
  }

  /**
   * Obtiene productos a partir del integrationId (no del courierId).
   * Internamente busca el courierId en la caché y llama al endpoint.
   */
  async getProducts(integrationId: string): Promise<ServiceOption[]> {
    console.log('🔍 CourierIntegrationApiAdapter - getProducts llamado con integrationId:', integrationId);
    console.log('🔍 CourierIntegrationApiAdapter - Cache actual:', this.integrationsCache);
    
    // Usamos 'let' para poder reasignar después
    let integration = this.integrationsCache.find(
      (i) => i.id === integrationId
    );

    console.log('🔍 CourierIntegrationApiAdapter - Integration encontrada:', integration);

    if (!integration) {
      console.log('🔍 CourierIntegrationApiAdapter - Integration no encontrada en cache, recargando...');
      // Si no hay cache (quizá no se llamó a getAll aún), recarga
      await this.getAll();
      // y vuelve a buscar
      integration = this.integrationsCache.find((i) => i.id === integrationId);
      console.log('🔍 CourierIntegrationApiAdapter - Integration después de recargar:', integration);
      if (!integration) {
        // No existe: devolvemos vacío
        console.log('🔍 CourierIntegrationApiAdapter - Integration no existe, retornando array vacío');
        return [];
      }
    }

    // Ahora sí tenemos el courierId real
    const { courierId } = integration;
    console.log('🔍 CourierIntegrationApiAdapter - Llamando a /couriers/${courierId}/services con courierId:', courierId);

    // Llama al endpoint con el courierId
    const raw = await this.httpClient.get<any>(
      `/couriers/${courierId}/services`
    );
    console.log('🔍 CourierIntegrationApiAdapter - Respuesta raw de servicios:', raw);
    
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    console.log('🔍 CourierIntegrationApiAdapter - List procesado:', list);
    
    const products = list.map((p: any) => ({
      id: String(p.id),
      name: p.description,
    }));
    
    console.log('🔍 CourierIntegrationApiAdapter - Productos mapeados:', products);
    return products;
  }

}
